import Box from '@mui/material/Box';
import React from 'react';

const separatorSx = theme => ({
  margin: '0 6px 0 20px',
  textIndent: '-999999px',
  borderRight: `1px solid ${theme.palette.secondary.light}`,
});

const Separator = () => (
  <Box component="div" sx={separatorSx}>
    |
  </Box>
);

export default Separator;
